import qs from 'qs';

import axiosInstance from '../protected';
import {getReportsUrl} from '../api.config';

import {IPageable} from '../../shared/types/pageable.types';
import {IDashboardPayload} from '../../shared/types/dashboard.types';
import {DashboardDto} from '../../shared/types/api-v2.types';

type TimeStampType = {beginDate: string; endDate: string} | {momentDate: string} | {};

export const ReportService = {
  async getAll(
    attr: {
      pageable?: IPageable;
      spec?: any;
    } = {},
  ) {
    const res = await axiosInstance.get<any>(getReportsUrl(), {
      params: {
        ...attr.pageable,
        ...attr.spec,
      },
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, {arrayFormat: 'repeat'});
        },
      },
    });

    return res;
  },

  async getById(id: string) {
    const res = await axiosInstance.get<any>(getReportsUrl(`/${id}`));

    return res;
  },

  async update(data: any) {
    const updated = await axiosInstance.put<any>(getReportsUrl(), data);

    return updated;
  },

  async getReportData(id: string, timeStamp: TimeStampType = {}) {
    return axiosInstance.post<any>(getReportsUrl(`/${id}/data`), timeStamp);
  },

  async getDashboard(params?: IDashboardPayload) {
    return await axiosInstance.get<DashboardDto>('/dashboard', {
      params,
    });
  },
};
